export default function UserCard({ title, count, color, icon }) {
    return (
        <div className="kpi-card kpi-clickable flex items-center gap-4 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-100">
            <div
                className="kpi-icon-container dark:ring-1 dark:ring-white/10"
                style={{ backgroundColor: color }}
            >
                <span className="kpi-icon">{icon}</span>
            </div>

            <div className="kpi-text-group">
                <div className="kpi-title dark:text-gray-400">{title}</div>
                <div className="kpi-value dark:text-white">{count}</div>
            </div>
        </div>
    );
}